import { Tooltip, Button, Modal } from "antd";
import { useState } from "react";
import useDelete from "hooks/useDelete";
import { DeleteOutlined } from "@ant-design/icons";

const DisconnectIssueModal = ({ is_disabled, issue_id, refetch }) => {
  const [is_open, setOpen] = useState(false);

  const { is_deleting, _delete } = useDelete({
    path: `/issues/${issue_id}`,
    onSuccess: () => [refetch(), setOpen(false)],
    success_message: "Usunięto zgłoszenie",
  });

  return (
    <>
      <Tooltip title="Usuń zgłoszenie">
        <Button
          disabled={is_disabled}
          onClick={() => setOpen(true)}
          danger
          ghost
          loading={is_deleting}
          type="primary"
          htmlType="button"
          icon={<DeleteOutlined />}
        />
      </Tooltip>
      {is_open && (
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={is_open}
          onOk={_delete}
          okButtonProps={{ loading: is_deleting }}
          onCancel={() => setOpen(false)}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          Czy na pewno chcesz usunąć zgłoszenie?
        </Modal>
      )}
    </>
  );
};

export default DisconnectIssueModal;
